@if (initialized && kpiHeaderDto) {
<!--    TODO Dependency-->
    <kpi-header [itemsArray]="kpiHeaderDto" [breadcrumb]="items" configRoute="/tm/config"
    ></kpi-header>


}